module.exports = __webpack_public_path__ + "img/cc.c1e8bdff.png";